module.exports = "/_next/static/images/Tools-75e082fc46918973e5f39d2233064532.png";